module.exports = __webpack_public_path__ + "static/media/tail-right.ab91d393.svg";